import colors from '../../../../lib/colors'

import { button } from '../../../../component/component'

export default function(o){

  if(!o.store('lang')){
    o.store('lang', 'en')
  }

  var toggle = function(){

    if(o.store('lang') == 'en'){
      o.store('lang','de')
    } else if(o.store('lang') == 'de'){
      o.store('lang','fr')
    } else if(o.store('lang') == 'fr'){
      o.store('lang','ru')
    } else if(o.store('lang') == 'ru'){
      o.store('lang','en')
    }

    div.html(o.store('lang').toUpperCase())

    requestAnimationFrame(function(){
      o.edit.update()
      o.search.update()
    })

  }

  if (o.store('role') == "admin" || o.store('role') == "author"){
    var right = '68px'
  } else {
    var right = '34px'
  }

  var div =
    button(o.store('lang').toUpperCase(),null,false,colors.yellow.s_600)
    .css({
      position: 'absolute',
      display: 'inline-block',
      right: right,
      textAlign: 'center',
      cursor: 'pointer',
    })
    .click(toggle)

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/admin/topbar/lang/lang.js